import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import Spinner from 'components/spinner';

import style from './style.module.css';

const getBaseButton = ({ href, fake }) => {
  // eslint-disable-next-line react/prop-types
  if (fake) return ({ children, ...rest }) => <div {...rest}>{children}</div>;
  if (href)
    // eslint-disable-next-line react/prop-types
    return ({ children, ...rest }) => (
      <Link to={href} {...rest}>
        {children}
      </Link>
    );

  // eslint-disable-next-line react/prop-types
  return ({ children, ...rest }) => (
    <button type="button" {...rest}>
      {children}
    </button>
  );
};

const Button = React.forwardRef(
  (
    {
      hierarchy,
      className,
      children,
      loading,
      href,
      disabled,
      fake,
      icon: Icon,
      ...rest
    },
    ref
  ) => {
    const customClassName = classNames(
      style.button,
      'button',
      className,
      style[`-${hierarchy}`],
      {
        [style['-disabled']]: disabled,
      }
    );

    const BaseButton = getBaseButton({ href, fake });

    return (
      <BaseButton
        {...rest}
        ref={ref}
        className={customClassName}
        to={href}
        disabled={disabled}
      >
        {Icon && !loading ? <Icon className={style.icon} /> : null}
        {loading ? <Spinner className={style.loading} small /> : null}
        {children}
      </BaseButton>
    );
  }
);

Button.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  hierarchy: PropTypes.oneOf(['primary', 'secondary', 'danger']),
  fake: PropTypes.bool,
  icon: PropTypes.func,
  loading: PropTypes.bool,
  href: PropTypes.string,
  disabled: PropTypes.bool,
};

Button.defaultProps = {
  hierarchy: 'primary',
  className: null,
  children: null,
  icon: null,
  loading: false,
  href: null,
  disabled: false,
  fake: false,
};

export default Button;
